export const stringifyArrayObjects = (data) => {
  const result = { ...data };

  for (const key in result) {
    if (
      Array.isArray(result[key]) &&
      result[key].every((item) => typeof item === "object")
    ) {
      result[key] = JSON.stringify(result[key]);
    }
  }

  return result;
};

export const parseNoteCheckboxFields = (notesArray) => {
  return notesArray.map((note) => {
    const parsedNote = { ...note };

    try {
      if (typeof parsedNote.checked === "string") {
        parsedNote.checked = JSON.parse(parsedNote.checked);
      }
    } catch {
      parsedNote.checked = [];
    }

    try {
      if (typeof parsedNote.unchecked === "string") {
        parsedNote.unchecked = JSON.parse(parsedNote.unchecked);
      }
    } catch {
      parsedNote.unchecked = [];
    }

    return parsedNote;
  });
};

export const getCookieDomain = () => {
  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return undefined; // Don't set domain on localhost
  }

  // Extract base domain like 'yourdomain.com' from 'sub.yourdomain.com'
  const parts = hostname.split(".");
  if (parts.length >= 2) {
    return `.${parts.slice(-2).join(".")}`; // e.g., .yourdomain.com
  }

  return undefined;
};
